import logger from 'redux-logger'
import CustomersSlice from 'gdl/customers/CustomersSlice'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import AdminFeaturesSlice from 'gdl/adminFeatures/AdminFeaturesSlice'
import CommercialFeaturesSlice from 'gdl/commercial/commercialFeature/CommercialFeaturesSlice'
import ProductsSlice from 'gdl/commercial/product/ProductsSlice'
import InstancesSlice from 'supervision/instances/InstancesSlice'
import ServicesSlice from 'supervision/services/ServicesSlice'
import VersionsSlice from 'versions/versionsSlice'
import UsersSlice from 'admin/users/UsersSlice'
import appSlice from 'app/appSlice'
import LicensesSlice from 'gdl/licenses/LicensesSlice'
import GlobalNoteSlice from 'gdl/globalNote/GlobalNoteSlice'

const rootReducer = combineReducers({
    gdl: combineReducers({
        adminFeatures: AdminFeaturesSlice.reducer,
        commercialFeatures: CommercialFeaturesSlice.reducer,
        products: ProductsSlice.reducer,
        customers: CustomersSlice.reducer,
        licenses: LicensesSlice.reducer,
        globalNote: GlobalNoteSlice.reducer,
    }),
    supervision: combineReducers({
        services: ServicesSlice.reducer,
        versions: VersionsSlice.reducer,
        instances: InstancesSlice.reducer,
    }),
    admin: combineReducers({
        users: UsersSlice.reducer,
    }),
    app: appSlice.reducer,
})

const AppStore = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
        logger,
    ],
    devTools: 'development',
})

export default AppStore